/**
 * Persist the signed-in user's experience-mode preference (full vs lite).
 * Hits GET/PUT /api/users/me/experience-mode. Unknown values coerce to "full".
 */

import { DEFAULT_EXPERIENCE_MODE, isExperienceMode, type TExperienceMode } from "@lexicanon/shared"
import { api } from "./client.ts"
import { unwrap } from "./errors.ts"

function coerceMode(value: unknown): TExperienceMode {
  return isExperienceMode(value) ? value : DEFAULT_EXPERIENCE_MODE
}

/** Read the signed-in user's experience mode. Unknown / missing → "full". */
export async function getExperienceMode(): Promise<TExperienceMode> {
  const response = unwrap(await api.api.users.me["experience-mode"].get())
  return coerceMode(response.data.mode)
}

/** Persist the signed-in user's experience mode. Unknown responses → "full". */
export async function updateExperienceMode(mode: TExperienceMode): Promise<TExperienceMode> {
  const response = unwrap(await api.api.users.me["experience-mode"].put({ mode }))
  return coerceMode(response.data.mode)
}
